'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthName$$anon$166(name$8, outer) {
  this.cde = null;
  this.cde = name$8;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$TwoFactorAuthName$$anon$166 as $c_Lpresto_types$TwoFactorAuthName$$anon$166 };
$p = $c_Lpresto_types$TwoFactorAuthName$$anon$166.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthName$$anon$166;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthName$$anon$166() {
}
export { $h_Lpresto_types$TwoFactorAuthName$$anon$166 as $h_Lpresto_types$TwoFactorAuthName$$anon$166 };
$h_Lpresto_types$TwoFactorAuthName$$anon$166.prototype = $p;
$p.nG = (function(seq) {
  return seq.b0(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((it) => {
    var this$2 = it.e4.l6;
    var this$4 = this$2.toLowerCase();
    var this$3 = this.cde;
    var s = this$3.toLowerCase();
    return ((this$4.indexOf(s) | 0) !== (-1));
  })));
});
var $d_Lpresto_types$TwoFactorAuthName$$anon$166 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthName$$anon$166, "presto.types$TwoFactorAuthName$$anon$166", ({
  a2t: 1,
  bM: 1
}));
export { $d_Lpresto_types$TwoFactorAuthName$$anon$166 as $d_Lpresto_types$TwoFactorAuthName$$anon$166 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Name$$anon$166.js.map
